/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { PowerOff, Power, X, AlertTriangle } from 'lucide-react';

export default function DeactivateClientModal({
    clientDetails,
    isActive,
    onConfirm,
    onCancel,
    loading = false,
}) {
    const [reason, setReason] = useState('');

   const handleConfirm = () => {
    onConfirm(reason.trim());
};

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div
                className="absolute inset-0 bg-black/40"
                onClick={!loading ? onCancel : undefined}
                role="presentation"
                onKeyDown={undefined}
            />

            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 z-10">

                <button
                    type="button"
                    onClick={onCancel}
                    disabled={loading}
                    className="absolute top-4 right-4 w-7 h-7 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 disabled:opacity-40"
                >
                    <X size={15} />
                </button>

                <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-4 ${isActive ? 'bg-red-50' : 'bg-blue-50'}`}>
                    {isActive
                        ? <AlertTriangle size={18} className="text-red-500" />
                        : <Power size={18} className="text-blue-500" />
                    }
                </div>

                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    {isActive ? 'Deactivate Organisation' : 'Reactivate Organisation'}
                </h3>
                <p className="text-xs text-gray-500 mb-4">
                    {isActive
                        ? 'The client admin and all learners under this org will lose access immediately.'
                        : 'The client admin and all learners under this org will regain access.'}
                </p>

                <div className="bg-gray-50 rounded-xl p-3 mb-5 text-sm space-y-1">
                    <div className="flex justify-between">
                        <span className="text-gray-500">Organisation</span>
                        <span className="font-medium text-gray-800">{clientDetails?.organizationName}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500">Admin</span>
                        <span className="font-medium text-gray-800">
                            {clientDetails?.clientAdmin?.fullName || clientDetails?.clientAdmin?.email || '—'}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500">Mode</span>
                        <span className={`text-xs px-2 py-0.5 rounded font-medium ${
                            clientDetails?.featureToggleMode === 'FULL_CREATOR'
                                ? 'bg-blue-100 text-blue-600'
                                : 'bg-gray-100 text-gray-600'
                        }`}>
                            {clientDetails?.featureToggleMode === 'FULL_CREATOR' ? 'Full Creator' : 'Run Only'}
                        </span>
                    </div>
                </div>

                <div className="mb-5">
                    <label
                        htmlFor="deactivate-reason"
                        className="text-xs font-medium text-gray-700 block mb-1"
                    >
                        Reason <span className="text-gray-400 font-normal">(optional)</span>
                    </label>
                    <textarea
                        id="deactivate-reason"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder={isActive
                            ? 'e.g. Contract ended, non-payment...'
                            : 'e.g. Contract renewed, issue resolved...'}
                        rows={2}
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-200 resize-none"
                    />
                </div>

                <div className="flex gap-2">
                    <button
                        type="button"
                        onClick={onCancel}
                        disabled={loading}
                        className="flex-1 py-2.5 text-sm border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 font-medium disabled:opacity-40"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        disabled={loading}
                        className={`flex-1 py-2.5 text-sm rounded-xl text-white font-medium flex items-center justify-center gap-2 disabled:opacity-50 ${
                            isActive ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-600 hover:bg-blue-700'
                        }`}
                    >
                        {loading ? (
                            <>
                                <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                                Processing...
                            </>
                        ) : (
                            <>
                                {isActive
                                    ? <><PowerOff size={14} /> Confirm Deactivate</>
                                    : <><Power size={14} /> Confirm Reactivate</>
                                }
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}